import { IconType } from "react-icons";

interface IProps {
  label: string;
  value?: string;
  icon: IconType;
  title?: string;
}

export function AccountValueField({
  label,
  value,
  icon: Icon,
  title,
}: IProps) {
  const displayValue = value || "Não informado";

  return (
    <div>
      <label className="form-label fw-semibold mb-2">{label}</label>
      <div className="input-group">
        <span className="input-group-text bg-light text-primary">
          <Icon className="fs-5" />
        </span>
        <div
          className="form-control d-flex align-items-center text-truncate"
          title={title || displayValue}
        >
          {displayValue}
        </div>
      </div>
    </div>
  );
}
